import * as React from 'react';
import Box from '@mui/material/Box';
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import GridWrapper from '../../grid/GridWrapper';
import { planoAPI, useGetStatsCollectionQuery } from '../../../redux/features/cache';
import { Produit } from '../../../models/Produit';
import { collectionHeaders } from '../../../constante/collectionHeaders';
import { useEffect } from 'react';
import { useAppDispatch } from '../../../redux/store';

export interface IStatsModalComponent {
    prod: any

}

export default function StatsModalComponent({ prod }: IStatsModalComponent) {
    const dispatch = useAppDispatch();
    let { data: stats = [] as Produit[], isSuccess } = useGetStatsCollectionQuery({ prod: prod });

    useEffect(() => {
        if (isSuccess && stats.length > 0) {
            let i = stats.map((e, i) => e.stats.primaire === true ? i : '').filter(String)
            if (i.length > 0) {
                dispatch(planoAPI.util.updateQueryData('getStatsCollection', { prod: prod }, (produit) => {
                    i.forEach((e) => {
                        produit[e as any].selected = produit[e as any].selected = true
                        return produit
                    })
                }))
            }

        }
    }, [stats])

    return (
        <div>
            <Box >
                {stats && (

                    <GridWrapper>
                        <Grid
                            data={stats}
                            rowHeight={40}
                            selectedField="selected"

                        >
                            {
                                collectionHeaders.map((item: any) => (
                                    <GridColumn
                                        key={item.champ}
                                        field={item.champ}
                                        title={item.label_champ}
                                        format={item.format_champ}
                                        headerClassName={`${item.format_champ === '{0:c}' ? 'alignRight' : ''}`}
                                        className={`${item.format_champ === '{0:c}' ? 'alignRight' : ''}`}
                                        width={150}
                                    />
                                ))}
                        </Grid>
                    </GridWrapper>
                )}
            </Box>
        </div >
    );
}